import clsx from 'clsx'
import { useFormContext } from 'react-hook-form'

import { CheckboxField } from '@/components/core-v2'

import { TradeTransferUnits } from '../unit-transfers-utilities/map-data'
import classes from './unit-transfers-asset.module.scss'
import { useUnitTransfersContext } from './unit-transfers-context'

interface UnitTransfersTradeProps {
  trade: TradeTransferUnits
}

const UnitTransfersTrade = ({ trade }: UnitTransfersTradeProps) => {
  const id = `${trade.id}-checkbox`
  const { getValues, setValue } = useFormContext()
  const { completed: assetsCompleted } = useUnitTransfersContext()
  let completed = 0
  trade.transferUnits.forEach(x => {
    if (assetsCompleted.includes(x.assetId)) completed++
  })
  if (completed < trade.transferUnits.length && getValues(id)) {
    setValue(id, false)
  }
  const label = `${completed}/${trade.transferUnits.length}`
  const isDisabled = completed < trade.transferUnits.length
  return (
    <div
      className={clsx(classes.cell, {
        [classes.valid]: completed === trade.transferUnits.length
      })}
    >
      <CheckboxField
        className={clsx(classes.checkBox)}
        id={id}
        isDisabled={isDisabled}
        label={label}
      />
      <span className={clsx(classes.tradeName)}>{trade.name}</span>
    </div>
  )
}

interface UnitTransfersTradesProps {
  trades: Map<string, TradeTransferUnits>
}

export const UnitTransfersTrades = ({ trades }: UnitTransfersTradesProps) => (
  <div className={clsx(classes.root, classes.tradeColumn)}>
    {[...trades.values()].map(trade => (
      <UnitTransfersTrade key={trade.id} trade={trade} />
    ))}
    <div className={clsx(classes.totals)}>
      <div>Total units to transfer</div>
      <div>Base value</div>
      <div>Units available at Finswitch</div>
      <div>Difference</div>
      <div>Current fund price</div>
    </div>
  </div>
)
